import Select from "@/components/base/Select";

const periods = ["هذا الأسبوع", "هذا الشهر", "3 شهور", "مخصص"];

const serviceOptions = [
  { value: "all", label: "كل الخدمات" },
  { value: "car", label: "غسيل سيارات" },
  { value: "home", label: "تنظيف منازل" },
  { value: "laundry", label: "مغاسل ملابس" },
];

interface FiltersBarProps {
  period: string;
  onPeriodChange: (p: string) => void;
  service: string;
  onServiceChange: (s: string) => void;
  onExportExcel: () => void;
  onExportPdf: () => void;
}

export default function FiltersBar({
  period,
  onPeriodChange,
  service,
  onServiceChange,
  onExportExcel,
  onExportPdf,
}: FiltersBarProps) {
  return (
    <div className="mt-5 flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
      {/* Period chips */}
      <div className="flex w-full flex-wrap items-center gap-1 rounded-full bg-white p-1 shadow-card sm:w-fit">
        {periods.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onPeriodChange(p)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              period === p
                ? "bg-[#0D6E6E] text-white"
                : "text-ghasla-text-secondary hover:text-ghasla-text-link"
            }`}
          >
            {p}
          </button>
        ))}
      </div>

      {/* Service filter + export */}
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
        <Select
          value={service}
          onChange={onServiceChange}
          options={serviceOptions}
          icon="ri-filter-3-line"
          className="w-full sm:w-[200px]"
        />
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onExportExcel}
            className="flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-xl border border-[#0D6E6E] px-4 text-sm font-medium text-ghasla-text-link transition-colors hover:bg-[#F0FDFD]"
          >
            <i className="ri-file-excel-2-line text-base" />
            تصدير Excel
          </button>
          <button
            type="button"
            onClick={onExportPdf}
            className="flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-xl border border-[#0D6E6E] px-4 text-sm font-medium text-ghasla-text-link transition-colors hover:bg-[#F0FDFD]"
          >
            <i className="ri-file-pdf-2-line text-base" />
            تصدير PDF
          </button>
        </div>
      </div>
    </div>
  );
}